// extracted by mini-css-extract-plugin
export var nearbyTrailsContainer = "styles-module__nearbyTrailsContainer___VvkFE";
export var nearbyTrailsHeader = "styles-module__nearbyTrailsHeader___vDcs7";
export var headerText = "styles-module__headerText___R3cpO";